class VkRetargeting {
    static init() {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.async = !0;
        script.src = "https://vk.com/js/api/openapi.js?169";
        script.onload = function() {
            VK.Retargeting.Init("VK-RTRG-1099235-9hpe");
            VK.Retargeting.Hit();
        };
        document.head.appendChild(script);
    }

    static isProgrammer() {
        return window.location.pathname === '/programmer' || window.location.pathname === '/programmer/';
    }

    static clickJoin() {
        if (!VkRetargeting.isProgrammer()) {
            return;
        }
        if (typeof VK === "undefined") {
            setTimeout(VkRetargeting.clickJoin, 500);
            return;
        }

        VK.Retargeting.Event('click-reg-button');
    }

    static formSubmit() {
        if (!VkRetargeting.isProgrammer()) {
            return;
        }
        if (typeof VK === "undefined") {
            setTimeout(VkRetargeting.formSubmit, 500);
            return;
        }

        VK.Retargeting.Event('form-fill-started');
    }
}
VkRetargeting.init();

$('.btn-join').click(function () {
    VkRetargeting.clickJoin();
});

$(document).on('form-submit', function () {
    VkRetargeting.formSubmit();
});
